<template>
  <nav ref="wrapRef" class="wholeview_wrap" v-bind="navDataAttrs">
    <button type="button" class="btn_wv" title="축소됨">
      <span class="sp_ui">전체메뉴</span>
    </button>

    <div id="wholeview" ref="wholeviewRef" style="-webkit-overflow-scrolling: touch; overflow-y: auto;">
      <div class="inr">
        <button type="button" class="w_close_btn">닫기</button>

        <div v-if="!isLoggedIn" class="head">
          <a href="https://www.daegu.go.kr/" class="daegu l_btn" target="_blank" title="새창열림">
            <img src="@/assets/images/common/img_daegu_x2.png" alt="대구광역시">
          </a>
          <RouterLink to="/login" class="login l_btn btn_login" @click="closeWholeview">로그인</RouterLink>
          <RouterLink to="/join" class="join l_btn btn_join" @click="closeWholeview">회원가입</RouterLink>
        </div>
        <div v-else class="head">
						<a href="https://www.daegu.go.kr/" class="daegu wh100 l_btn" target="_blank" title="새창열림">
              <img src="@/assets/images/common/img_daegu_x2.png" alt="대구광역시">
            </a>
            <RouterLink to="/my-rsvt/list" class="l_btn mypage" @click="closeWholeview">마이페이지</RouterLink>
            <a href="#" class="l_btn logout" @click.prevent="logout">로그아웃</a>
            <RouterLink to="/my-info-edit/detail" class="l_btn mypage" @click="closeWholeview">정보수정</RouterLink>
				</div>
        <h2 class="title_wv">menu</h2>

        <ul class="nav">
          <li v-for="sec in headerNav" :key="sec.menuId">
            <a
              :href="hrefForMenu(sec, true) || '#'"
              :target="getTargetAttr(sec)"
              :rel="relFor(sec)"
              :title="sec.title || undefined"
              :class="{ parent: sec.children?.length }"
              :data-menu-id="sec.menuId"
              :data-up-menu-id="sec.upMenuId"
              :data-type-menu="sec.menuNm"
              @click="onRootClick($event, sec)"
            >
              <span>{{ sec.menuNm }}</span>
              <span v-if="sec.children?.length" class="unfd"> 펼치기</span>
            </a>

            <div v-if="sec.children?.length">
              <ul>
                <li v-for="child in sec.children" :key="child.menuId">
                  <a
                    :href="hrefForMenu(child) || '#'"
                    :target="getTargetAttr(child)"
                    :rel="relFor(child)"
                    :title="child.title || undefined"
                    :class="{ parent: child.children?.length }"
                    :data-menu-id="child.menuId"
                    :data-up-menu-id="child.upMenuId"
                    @click="onChildClick($event, child)"
                  >
                    <span v-if="isExternalLink(child)">{{ child.menuNm }}</span>
                    <template v-else>{{ child.menuNm }}</template>
                    <span v-if="child.children?.length" class="unfd"> 펼치기</span>
                  </a>

                  <ul v-if="child.children?.length">
                    <li v-for="grandchild in child.children" :key="grandchild.menuId">
                        <a
                          :href="hrefForMenu(grandchild) || '#'"
                          :target="getTargetAttr(grandchild)"
                          :rel="relFor(grandchild)"
                          :title="grandchild.title || undefined"
                          :class="{ parent: grandchild.children?.length }"
                          :data-menu-id="grandchild.menuId"
                          :data-up-menu-id="grandchild.upMenuId"
                          @click="onGrandchildClick($event, grandchild)"
                        >
                          <span v-if="isExternalLink(grandchild)">{{ grandchild.menuNm }}</span>
                          <template v-else>{{ grandchild.menuNm }}</template>
                          <span v-if="grandchild.children?.length" class="unfd"> 펼치기</span>
                        </a>

                        <ul v-if="grandchild.children?.length">
                          <li v-for="greatgrandchild in grandchild.children" :key="greatgrandchild.menuId">
                              <a
                                :href="hrefForMenu(greatgrandchild) || '#'"
                                :target="getTargetAttr(greatgrandchild)"
                                :rel="relFor(greatgrandchild)"
                                :title="greatgrandchild.title || undefined"
                                :data-menu-id="greatgrandchild.menuId"
                                :data-up-menu-id="greatgrandchild.upMenuId"
                                @click.prevent="handleNavigate(greatgrandchild)"
                              >
                                <span v-if="isExternalLink(greatgrandchild)">{{ greatgrandchild.menuNm }}</span>
                                <template v-else>{{ greatgrandchild.menuNm }}</template>
                              </a>
                          </li>
                        </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="dim_wv"></div>
  </nav>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, useAttrs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/store/user.store'
import { customMemberLogout } from '@/service/auth.service'
import { countMenuAccess } from '@/service/stats.service'

defineOptions({ name: 'MobileMenu', inheritAttrs: false })

const attrs = useAttrs()

const navDataAttrs = computed(() => {
  const out = {}

  if (attrs['selected-menu-id'] != null) {
    out['data-selected-menu-id'] = attrs['selected-menu-id']
  }

  if (attrs.selectedMenuId != null) {
    out['data-selected-menu-id'] = attrs.selectedMenuId
  }

  return out
})

const wrapRef = ref(null)
const wholeviewRef = ref(null)
const searchWrapRef = ref(null)
const cleanupFns = []

const router = useRouter()
const route = useRoute()

const props = defineProps({
  menus: { type: Array, default: () => [] },
  isLoggedIn: { type: Boolean, default: false },
})

const emit = defineEmits(['menu-change', 'logout'])

const isVisibleMenu = (menu) =>
  menu?.menuIndctYn === 'Y' || menu?.menuIndctYn === 'YES'

const buildVisibleMenuTree = (menus) => {
  const list = Array.isArray(menus) ? menus : []
  return list
    .filter(isVisibleMenu)
    .map((menu) => ({
      ...menu,
      children: buildVisibleMenuTree(menu.children),
    }))
}

const headerNav = computed(() => buildVisibleMenuTree(props.menus))

const normalizeLink = (raw) => {
  const link = String(raw || '').trim()
  if (!link || link === 'dir' || link === 'N') return null
  if (/^https?:\/\//i.test(link)) return link
  return link.startsWith('/') ? link : `/${link}`
}

const findFirstNavigableHref = (nodes) => {
  if (!Array.isArray(nodes)) return null
  for (const node of nodes) {
    const href = normalizeLink(node?.path) || normalizeLink(node?.menuLink)
    if (href) return href
    const childHref = findFirstNavigableHref(node.children)
    if (childHref) return childHref
  }
  return null
}

const hrefForMenu = (menu) => {
  const direct = normalizeLink(menu?.path) || normalizeLink(menu?.menuLink)
  if (direct) return direct

  if (menu?.children?.length > 0) {
    return findFirstNavigableHref(menu.children)
  }

  return null
}

const closeWholeview = () => {
  const wrap = wrapRef.value
  if (!wrap) return

  wrap.classList.remove('open')

  // body.open_wv의 position:fixed 해제 시 스크롤 위치 복원
  const savedScrollY = parseInt(document.body.style.top || '0', 10) * -1
  document.body.classList.remove('open_wv')
  document.body.style.top = ''
  if (savedScrollY) {
    window.scrollTo(0, savedScrollY)
  }

  const btnWv = wrap.querySelector('.btn_wv')
  if (btnWv) btnWv.setAttribute('title', '축소됨')

  // iOS Safari: dim_wv pointer-events 비활성화
  const dimWv = wrap.querySelector('.dim_wv')
  if (dimWv) dimWv.style.pointerEvents = 'none'
}

const userStore = useUserStore()
const server = import.meta.env.VITE_DEFAULT_SERVER_URL || ''

const logout = async () => {
  closeWholeview()
  try {
    const result = await customMemberLogout()
    const redirectUrl = result?.redirectUrl || server
    sessionStorage.clear()
    userStore.logout()
    window.location.href = redirectUrl
  } catch {
    sessionStorage.clear()
    userStore.logout()
    window.location.href = server
  }
}

const handleNavigate = async (menu) => {
  const href = hrefForMenu(menu)
  if (!href) return

  // 메뉴 접속수 카운트
  if (menu.menuId) {
    countMenuAccess({ menuUrl: href, menuId: menu.menuId }).catch(() => {})
  }

  closeWholeview()
  emit('menu-change', menu.menuId)

  if (/^https?:\/\//i.test(href)) {
    window.location.href = href
    return
  }
  await router.push(href)
}

const onRootClick = async (e, sec) => {
  if (sec?.children?.length) {
    e.preventDefault()
    return
  }
  e.preventDefault()
  await handleNavigate(sec)
}

const onChildClick = async (e, child) => {
  if (child?.children?.length) {
    e.preventDefault()
    return
  }
  e.preventDefault()
  await handleNavigate(child)
}

const onGrandchildClick = async (e, grandchild) => {
  if (grandchild?.children?.length) {
    e.preventDefault()
    return
  }
  e.preventDefault()
  await handleNavigate(grandchild)
}

const relFor = (item) => item?.rel || (item?.target === '_blank' ? 'noopener noreferrer' : undefined)

const isExternalLink = (menu) => {
  const href = hrefForMenu(menu)
  return href && /^https?:\/\//i.test(href)
}

const getTargetAttr = (menu) => {
  // menuType이 LINK이면 외부 링크로 간주
  if (menu?.menuType === 'LINK') return '_blank'
  // 명시적으로 target이 설정되어 있으면 사용
  if (menu?.target) return menu.target
  // href가 http(s)로 시작하면 외부 링크
  if (isExternalLink(menu)) return '_blank'
  return undefined
}

onMounted(() => {
  const wrap = wrapRef.value
  const wholeview = wholeviewRef.value
  const searchWrap = searchWrapRef.value
  if (!wrap || !wholeview) return

  const btnWv = wrap.querySelector('.btn_wv')
  const setBtnTitle = (open) => btnWv && btnWv.setAttribute('title', open ? '확장됨' : '축소됨')

  const wvOn = () => {
    // body position:fixed 적용 전 현재 스크롤 위치 저장
    const scrollY = window.scrollY || window.pageYOffset
    document.body.style.top = `-${scrollY}px`

    wrap.classList.add('open')
    document.body.classList.add('open_wv')
    setBtnTitle(true)

    // iOS Safari: dim_wv pointer-events 활성화
    const dimWv = wrap.querySelector('.dim_wv')
    if (dimWv) dimWv.style.pointerEvents = 'auto'
  }

  const wvOff = () => {
    const savedScrollY = parseInt(document.body.style.top || '0', 10) * -1
    wrap.classList.remove('open')
    document.body.classList.remove('open_wv')
    document.body.style.top = ''
    setBtnTitle(false)
    if (savedScrollY) {
      window.scrollTo(0, savedScrollY)
    }
  }

  // 마이페이지 경로 여부
  const isMyPage = () => {
    const p = route.path
    return p.startsWith('/my-rsvt') || p.startsWith('/my-info-edit')
  }

  const applyCurrentMenuActive = () => {
    wholeview.querySelectorAll('.nav a.on').forEach((a) => a.classList.remove('on'))
    wholeview.querySelectorAll('.nav li.open').forEach((li) => li.classList.remove('open'))

    // 마이페이지는 메뉴 활성화 없이 종료
    if (isMyPage()) return

    try {
      const menuId = document.body.getAttribute('data-menu-type') || ''
      const menuIdUp = document.body.getAttribute('data-menu-idup') || ''
      const menuIdTop = document.body.getAttribute('data-menu-idtop') || ''
      let markedCount = 0

      const markByMenuId = (v) => {
        if (!v) return 0
        const els = wholeview.querySelectorAll(`a[data-menu-id="${v}"]`)
        els.forEach((a) => a.classList.add('on'))
        return els.length
      }

      const markByHref = (v) => {
        if (!v) return 0
        const els = wholeview.querySelectorAll(`a[href*="${v}"]`)
        els.forEach((a) => a.classList.add('on'))
        return els.length
      }

      markedCount += markByMenuId(menuIdTop)
      markedCount += markByMenuId(menuIdUp)
      markedCount += markByMenuId(menuId)

      // fallback: href 기준
      if (markedCount === 0) {
        markedCount += markByHref(menuId)
        markedCount += markByHref(menuIdUp)
        markedCount += markByHref(menuIdTop)
      }

      // 메인 페이지(/) 이거나 매칭 메뉴가 없으면 첫 번째 메뉴 활성화
      if (markedCount === 0 || route.path === '/') {
        wholeview.querySelectorAll('.nav a.on').forEach((a) => a.classList.remove('on'))
        wholeview.querySelector('.nav > li:first-child > a')?.classList.add('on')
      }
    } catch {
      wholeview.querySelector('.nav > li:first-child > a')?.classList.add('on')
    }

    wholeview.querySelectorAll('.nav a.on').forEach((a) => a.closest('li')?.classList.add('open'))
    wholeview.querySelectorAll('.nav a .unfd').forEach((s) => { s.textContent = ' 펼치기' })
    wholeview.querySelectorAll('.nav a.on .unfd').forEach((s) => { s.textContent = ' 접기' })

    // 첫 번째 메뉴가 활성화된 경우 자식이 있으면 자동으로 열기
    const firstLi = wholeview.querySelector('.nav > li:first-child')
    if (firstLi?.querySelector('a.on')) {
      const firstParentA = firstLi.querySelector('a.parent')
      if (firstParentA) {
        firstLi.classList.add('open')
        firstParentA.classList.add('on')
        const unfd = firstParentA.querySelector('.unfd')
        if (unfd) unfd.textContent = ' 접기'
      }
    }
  }

  const unbind = []

  const onClickWrap = (e) => {
    const t = e.target.closest('.btn_wv, .dim_wv, .w_close_btn')
    if (!t || !wrap.contains(t)) return
    e.preventDefault()
    if (wrap.classList.contains('open')) {
      wvOff()
    } else {
      applyCurrentMenuActive()
      wvOn()
    }
  }
  wrap.addEventListener('click', onClickWrap)
  unbind.push(() => wrap.removeEventListener('click', onClickWrap))

  applyCurrentMenuActive()

  const onClickNav = (e) => {
    let a = e.target
    // a 태그가 아니면 부모 a 태그 찾기 (최대 3단계)
    if (a.tagName !== 'A') {
      a = a.closest('a')
    }
    if (!a || !a.classList.contains('parent')) return
    
    // 실제로 .nav li > a.parent인지 확인
    const li = a.parentElement
    if (!li || li.tagName !== 'LI') return
    
    e.preventDefault()
    e.stopPropagation()

    const opened = li.classList.contains('open')

    // 형제 요소들 처리
    const parentUl = li.parentElement
    if (parentUl) {
      Array.from(parentUl.children).forEach((s) => {
        if (s !== li && s.tagName === 'LI') {
          s.classList.remove('open')
          const siblingA = s.querySelector('a')
          if (siblingA) {
            siblingA.classList.remove('on')
            const u = siblingA.querySelector('.unfd')
            if (u) u.textContent = ' 펼치기'
          }
        }
      })
    }

    li.classList.toggle('open', !opened)
    a.classList.toggle('on', !opened)
    const unfd = a.querySelector('.unfd')
    if (unfd) unfd.textContent = opened ? ' 펼치기' : ' 접기'
  }
  wholeview.addEventListener('click', onClickNav)
  unbind.push(() => wholeview.removeEventListener('click', onClickNav))

  if (searchWrap) {
    const srchOn = () => {
      searchWrap.classList.add('open')
      searchWrap.querySelectorAll('.btn_open, .btn_close').forEach((b) => b.setAttribute('title', '확장됨'))
      wvOff()
    }
    const srchOff = () => {
      searchWrap.classList.remove('open')
      searchWrap.querySelectorAll('.btn_open, .btn_close').forEach((b) => b.setAttribute('title', '축소됨'))
    }
    const onClickSearch = (e) => {
      const b = e.target.closest('.btn_open, .btn_close')
      if (!b || !searchWrap.contains(b)) return
      e.preventDefault()
      searchWrap.classList.contains('open') ? srchOff() : srchOn()
    }
    searchWrap.addEventListener('click', onClickSearch)
    unbind.push(() => searchWrap.removeEventListener('click', onClickSearch))
  }

  cleanupFns.push(...unbind)
})

onBeforeUnmount(() => {
  cleanupFns.forEach((fn) => fn())
})
</script>
